import { Outlet } from 'react-router-dom';
import { Header } from '../components/Header/Header';
import { Footer } from '../components/Footer/Footer';
import styles from './AppLayout.module.scss';

interface AppLayoutProps {
  children?: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps = {}) {
  return (
    <div className={styles.layout}>
      <Header />

      <main id="voltMainContent" className={styles.main}>
        <div className={styles.page}>
          {children !== undefined ? children : <Outlet />}
        </div>
      </main>

      <Footer />
    </div>
  );
}
